import React, { useState, Fragment } from 'react';
import { message } from 'antd';
import InputPasswordToggle from './../../@core/components/input-password-toggle'
import { Link, useHistory } from 'react-router-dom'
import Axios from 'axios';
import classnames from 'classnames'
import { useForm } from 'react-hook-form';
import { Form, Input, FormGroup, Label, CustomInput, Button, FormFeedback } from 'reactstrap'
import { url } from '../../config/global';
import './Login.css';

function Login(props) {

  const { register, errors, handleSubmit } = useForm();
  const [login, setLogin] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);
  const [error, setError] = useState(null);
  const [errorInputs, setErrorInputs] = useState('');
  const [twoFactor, setTwoFactor] = useState(null);
  const [twoFactorMethod, setTwoFactorMethod] = useState('');
  const [twoFactorCode, setTwoFactorCode] = useState('');
  const [twoFactorStep, setTwoFactorStep] = useState('select');
  const [authenticatorSetup, setAuthenticatorSetup] = useState(null);
  const [authenticatorReverify, setAuthenticatorReverify] = useState({
    emailCode: '',
    authenticatorCode: '',
    qrCode: '',
    secret: '',
  });
  // ./../assets/img/banner-dashboard.png
  const urlLogo = require(`./../../assets/img/banner-dashboard.png`).default
  const bgLogin = require(`./../../assets/images/pages/login-v2.svg`).default
  

  const handleChange = (name, value) => {
    if(name === 'password') {
      if(value.length >= 6) {
        setErrorInputs(null);
      }

      setLogin({
        ...login,
        [name]: value,
      });


    } else {
      setLogin({
        ...login,
        [name]: value,
      });
    }
  };

  const handleLogin = async () => {
    setLoading(true);
    await Axios.post(`${url}/login`, {
      username: login.username,
      password: login.password,
    }).then((res) => {
      if (res.data.requires_2fa) {
        const defaultMethod = res.data.methods && res.data.methods.length > 0 ? res.data.methods[0] : '';
        setTwoFactor(res.data);
        setTwoFactorMethod(defaultMethod);
        setTwoFactorCode('');
        setTwoFactorStep('select');
        setAuthenticatorSetup(null);
        resetAuthenticatorReverify();
        message.info(res.data.message);
        setLoading(false);
        return;
      }

      handleLoginSuccess(res.data);
      setLoading(false);
    }).catch((err) => {
      message.error(err.response ? err.response.data.message : 'Login gagal.');
      setLoading(false);
      if (err.response && err.response.status === 422) {
        setError(err.response.data.errors)
        setErrorInputs(err.response.data.errors)
      } else {

      }
    });
  };

  const handleLoginSuccess = (payload) => {
    sessionStorage.setItem('token', payload.token);
    sessionStorage.setItem('fullname', payload.data.full_name);
    sessionStorage.setItem('avatar', payload.data.photo ? payload.data.photo_url : '');
    sessionStorage.setItem('permissions', JSON.stringify(payload.permissions));
    sessionStorage.setItem('redirect', payload.redirect);
    sessionStorage.setItem('_id', payload.data._id);

    message.success(payload.message);
    props.history.push(payload.redirect);
  };

  const handleSendEmailOtp = async () => {
    setLoadingOtp(true);
    await Axios.post(`${url}/2fa/email/send-login`, {
      challenge_token: twoFactor.challenge_token,
    }).then((res) => {
      if (res.data.challenge_token) {
        setTwoFactor((current) => ({ ...current, challenge_token: res.data.challenge_token }));
      }
      message.success(res.data.message);
      setTwoFactorStep('verify');
    }).catch((err) => {
      message.error(err.response ? err.response.data.message : 'Gagal mengirim OTP.');
    }).finally(() => setLoadingOtp(false));
  };

  const resetAuthenticatorReverify = () => {
    setAuthenticatorReverify({
      emailCode: '',
      authenticatorCode: '',
      qrCode: '',
      secret: '',
    });
  };

  const handleContinueTwoFactor = async () => {
    if (!twoFactorMethod) {
      message.error('Pilih metode verifikasi terlebih dahulu.');
      return;
    }

    setTwoFactorCode('');
    resetAuthenticatorReverify();

    if (twoFactorMethod === 'email') {
      await handleSendEmailOtp();
      return;
    }

    setLoadingOtp(true);
    await Axios.post(`${url}/2fa/authenticator/setup-login`, {
      challenge_token: twoFactor.challenge_token,
    }).then((res) => {
      if (res.data.challenge_token) {
        setTwoFactor((current) => ({ ...current, challenge_token: res.data.challenge_token }));
      }
      setAuthenticatorSetup(res.data.setup_required ? res.data : null);
      setTwoFactorStep('verify');
    }).catch((err) => {
      message.error(err.response ? err.response.data.message : 'Gagal menyiapkan authenticator.');
    }).finally(() => setLoadingOtp(false));
  };

  const handleSendAuthenticatorReverifyOtp = async () => {
    setLoadingOtp(true);
    await Axios.post(`${url}/2fa/authenticator/reverify-login/send-email`, {
      challenge_token: twoFactor.challenge_token,
    }).then((res) => {
      if (res.data.challenge_token) {
        setTwoFactor((current) => ({ ...current, challenge_token: res.data.challenge_token }));
      }
      message.success(res.data.message);
      resetAuthenticatorReverify();
      setTwoFactorStep('reverify-email');
    }).catch((err) => {
      message.error(err.response ? err.response.data.message : 'Gagal mengirim OTP reverifikasi QR.');
    }).finally(() => setLoadingOtp(false));
  };

  const handleVerifyAuthenticatorReverifyEmail = async () => {
    if (authenticatorReverify.emailCode.length !== 6) {
      message.error('Masukkan 6 digit OTP email.');
      return;
    }

    setLoadingOtp(true);
    await Axios.post(`${url}/2fa/authenticator/reverify-login/verify-email`, {
      challenge_token: twoFactor.challenge_token,
      code: authenticatorReverify.emailCode,
    }).then((res) => {
      if (res.data.challenge_token) {
        setTwoFactor((current) => ({ ...current, challenge_token: res.data.challenge_token }));
      }
      message.success(res.data.message);
      setAuthenticatorReverify((current) => ({
        ...current,
        authenticatorCode: '',
        qrCode: res.data.qr_code,
        secret: res.data.secret,
      }));
      setTwoFactorStep('reverify-qr');
    }).catch((err) => {
      message.error(err.response ? err.response.data.message : 'Kode OTP email tidak valid.');
    }).finally(() => setLoadingOtp(false));
  };

  const handleVerifyTwoFactor = async (code = twoFactorCode) => {
    setLoading(true);
    await Axios.post(`${url}/2fa/verify-login`, {
      challenge_token: twoFactor.challenge_token,
      method: twoFactorMethod,
      code,
    }).then((res) => {
      handleLoginSuccess(res.data);
    }).catch((err) => {
      message.error(err.response ? err.response.data.message : 'Kode verifikasi tidak valid.');
    }).finally(() => setLoading(false));
  };

  const handleTwoFactorSubmit = (e) => {
    e.preventDefault();

    if (twoFactorStep === 'select') {
      handleContinueTwoFactor();
      return;
    }

    if (twoFactorStep === 'reverify-email') {
      handleVerifyAuthenticatorReverifyEmail();
      return;
    }

    if (twoFactorStep === 'reverify-qr') {
      handleVerifyTwoFactor(authenticatorReverify.authenticatorCode);
      return;
    }

    handleVerifyTwoFactor();
  };

  return (
    <>
      <div className="app-content content ">
        <div className="content-overlay"></div>
        <div className="header-navbar-shadow"></div>
        <div className="content-wrapper">
          <div className="content-header row">
          </div>
          <div className="content-body">
            <div className="auth-wrapper auth-v2">
              <div className="auth-inner p-0 row m-0">
                <Link className='brand-logo login' to='/' onClick={e => e.preventDefault()}>
                  <img className='img-fluid' style={{width: 150}} src={urlLogo} alt='Login V2' />
                </Link>
                  <div className="d-none d-lg-flex col-lg-8 align-items-center p-5">
                    <div className="w-100 d-lg-flex align-items-center justify-content-center px-5">
                      <img className="img-fluid" src={bgLogin} alt="Login V2" />
                    </div>
                  </div>
                  <div className="d-flex col-lg-4 align-items-center shadow auth-bg px-2 p-lg-5">
                    <div className="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                      <p className="card-text mb-0 text-center">Portal Single Account</p>
                      <p className="card-text mb-0 text-center">Untuk Login Multi Aplikasi</p>
                      {twoFactor ? (
                        <Form className='auth-login-form mt-2' onSubmit={handleTwoFactorSubmit}>
                          {twoFactorStep === 'select' ? (
                            <>
                              <FormGroup>
                                <Label className='form-label'>Pilih Verifikasi 2 Langkah</Label>
                                {twoFactor.methods && twoFactor.methods.includes('authenticator') && (
                                  <CustomInput
                                    type='radio'
                                    id='method-authenticator'
                                    name='two_factor_method'
                                    label='QR Authenticator'
                                    checked={twoFactorMethod === 'authenticator'}
                                    onChange={() => setTwoFactorMethod('authenticator')}
                                  />
                                )}
                                {twoFactor.methods && twoFactor.methods.includes('email') && (
                                  <CustomInput
                                    type='radio'
                                    id='method-email'
                                    name='two_factor_method'
                                    label={`OTP Email${twoFactor.email_hint ? ` (${twoFactor.email_hint})` : ''}`}
                                    checked={twoFactorMethod === 'email'}
                                    onChange={() => setTwoFactorMethod('email')}
                                  />
                                )}
                              </FormGroup>
                              <Button type='submit' color='primary' block className='bg-success border border-success' disabled={loadingOtp || !twoFactorMethod}>
                                {loadingOtp ? 'Memproses...' : 'Selanjutnya'}
                              </Button>
                            </>
                          ) : twoFactorStep === 'reverify-email' ? (
                            <>
                              <FormGroup>
                                <Label className='form-label' for='authenticator-reverify-email-code'>
                                  OTP Email
                                </Label>
                                <Input
                                  autoFocus
                                  type='text'
                                  id='authenticator-reverify-email-code'
                                  value={authenticatorReverify.emailCode}
                                  maxLength={6}
                                  placeholder='6 digit OTP email'
                                  onChange={(e) => setAuthenticatorReverify((current) => ({
                                    ...current,
                                    emailCode: e.target.value.replace(/\D/g, ''),
                                  }))}
                                />
                              </FormGroup>
                              <Button type='submit' color='primary' block className='bg-success border border-success' disabled={loadingOtp || authenticatorReverify.emailCode.length !== 6}>
                                {loadingOtp ? 'Memverifikasi...' : 'Verifikasi Email'}
                              </Button>
                              <Button
                                type='button'
                                color='secondary'
                                outline
                                block
                                disabled={loadingOtp}
                                onClick={handleSendAuthenticatorReverifyOtp}>
                                {loadingOtp ? 'Mengirim OTP...' : 'Kirim Ulang OTP Email'}
                              </Button>
                              <Button type='button' color='link' block onClick={() => { setTwoFactorStep('verify'); resetAuthenticatorReverify(); }}>
                                Kembali ke verifikasi QR
                              </Button>
                            </>
                          ) : twoFactorStep === 'reverify-qr' ? (
                            <>
                              <FormGroup className='text-center'>
                                <img
                                  alt='QR Authenticator'
                                  src={`data:image/svg+xml;base64,${authenticatorReverify.qrCode}`}
                                  style={{ width: 180, height: 180 }}
                                />
                                <Input className='mt-1 text-center' value={authenticatorReverify.secret} readOnly />
                              </FormGroup>
                              <FormGroup>
                                <Label className='form-label' for='authenticator-reverify-code'>
                                  Kode Authenticator
                                </Label>
                                <Input
                                  autoFocus
                                  type='text'
                                  id='authenticator-reverify-code'
                                  value={authenticatorReverify.authenticatorCode}
                                  maxLength={6}
                                  placeholder='6 digit kode'
                                  onChange={(e) => setAuthenticatorReverify((current) => ({
                                    ...current,
                                    authenticatorCode: e.target.value.replace(/\D/g, ''),
                                  }))}
                                />
                              </FormGroup>
                              <Button type='submit' color='primary' block className='bg-success border border-success' disabled={loading || authenticatorReverify.authenticatorCode.length !== 6}>
                                {loading ? 'Memverifikasi...' : 'Simpan QR Baru & Login'}
                              </Button>
                              <Button type='button' color='link' block onClick={() => { setTwoFactorStep('verify'); resetAuthenticatorReverify(); }}>
                                Kembali ke verifikasi QR
                              </Button>
                            </>
                          ) : (
                            <>
                              {twoFactorMethod === 'authenticator' && authenticatorSetup && (
                                <FormGroup className='text-center'>
                                  <img
                                    alt='QR Authenticator'
                                    src={`data:image/svg+xml;base64,${authenticatorSetup.qr_code}`}
                                    style={{ width: 180, height: 180 }}
                                  />
                                  <Input className='mt-1 text-center' value={authenticatorSetup.secret} readOnly />
                                </FormGroup>
                              )}
                              {twoFactorMethod === 'authenticator' && !authenticatorSetup && (
                                <>
                                  <p className='text-muted text-center'>
                                    Buka Authenticator lalu masukkan kode 6 digit dari akun ini.
                                  </p>
                                  <FormGroup>
                                    <Button
                                      type='button'
                                      color='secondary'
                                      outline
                                      block
                                      disabled={loadingOtp}
                                      onClick={handleSendAuthenticatorReverifyOtp}>
                                      {loadingOtp ? 'Mengirim OTP...' : 'Reverifikasi QR Authenticator'}
                                    </Button>
                                  </FormGroup>
                                </>
                              )}
                              {twoFactorMethod === 'email' && (
                                <FormGroup>
                                  <Button
                                    type='button'
                                    color='secondary'
                                    outline
                                    block
                                    disabled={loadingOtp}
                                    onClick={handleSendEmailOtp}>
                                    {loadingOtp ? 'Mengirim OTP...' : 'Kirim Ulang OTP Email'}
                                  </Button>
                                </FormGroup>
                              )}
                              <FormGroup>
                                <Label className='form-label' for='two-factor-code'>
                                  Kode Verifikasi
                                </Label>
                                <Input
                                  autoFocus
                                  type='text'
                                  id='two-factor-code'
                                  value={twoFactorCode}
                                  maxLength={6}
                                  placeholder='6 digit kode'
                                  onChange={(e) => setTwoFactorCode(e.target.value.replace(/\D/g, ''))}
                                />
                              </FormGroup>
                              <Button type='submit' color='primary' block className='bg-success border border-success' disabled={loading || twoFactorCode.length !== 6}>
                                {loading ? 'Memverifikasi...' : 'Verifikasi'}
                              </Button>
                              <Button type='button' color='link' block onClick={() => { setTwoFactorStep('select'); setAuthenticatorSetup(null); setTwoFactorCode(''); resetAuthenticatorReverify(); }}>
                                Ganti metode
                              </Button>
                            </>
                          )}
                          <Button type='button' color='link' block onClick={() => { setTwoFactor(null); setAuthenticatorSetup(null); setTwoFactorCode(''); resetAuthenticatorReverify(); }}>
                            Kembali ke login
                          </Button>
                        </Form>
                      ) : (
                      <Form className='auth-login-form mt-2' onSubmit={handleSubmit(handleLogin)}>
                        <FormGroup>
                          <Label className='form-label' for='login-username'>
                            Username
                          </Label>
                          <Input
                            autoFocus
                            type='text'
                            value={login.username}
                            id='login-user'
                            name='username'
                            placeholder='username'
                            onChange={(e) => handleChange('username', e.target.value)}
                            className={classnames({ 'is-invalid': errors['username'] })}
                            innerRef={register({ required: true, validate: value => value !== '' })}
                          />
                        </FormGroup>
                        <FormGroup>
                          <div className='d-flex justify-content-between'>
                            <Label className='form-label' for='login-password'>
                              Password
                            </Label>
                            
                          </div>
                          {/* <Input
                            type='password'
                            id='login-password'
                            name='password'
                            onChange={(e) => handleChange('password', e.target.value)}
                            className={error ? 'is-invalid' : ''}
                            innerRef={register({ required: true, validate: value => value !== '' })}
                            invalid={errors.password && true}
                            placeholder='password'
                          /> */}
                          <InputPasswordToggle
                            value={login.password}
                            id='login-password'
                            name='password'
                            onChange={(e) => handleChange('password', e.target.value)}
                            // className={'is-invalid'}
                            className={errorInputs ? 'is-invalid' : ''}
                            innerRef={register({ required: true, validate: value => value !== '' })}
                          />
                          {errorInputs && <FormFeedback>{errorInputs['password']}</FormFeedback>}
                        </FormGroup>
                        <FormGroup>
                          <div className='d-flex justify-content-between'>
                            <CustomInput type='checkbox' className='custom-control-Primary' id='remember-me' label='Remember Me' />
                            <Link to='/forgot-password'>
                              <small>Forgot Password?</small>
                            </Link>
                          </div>
                        </FormGroup>
                        <Button type='submit' color='primary' block className='bg-success border border-success' disabled={loading}>
                          {loading ? 
                            <>
                              <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                              <span className="ml-25 align-middle">Sign in...</span>
                            </>
                          : 
                            <>
                              <span className="ml-25 align-middle">Sign in</span>
                            </>
                          }
                        </Button>
                      </Form>
                      )}
                      {/* <p className="text-center mt-2"><span>New on our platform?</span><a href="page-auth-register-v2.html"><span>&nbsp;Create an account</span></a></p> */}
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
